module.exports = __webpack_public_path__ + "img/mystery-box.89c7cbf.webp";